var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _c("md-dialog-title", [_vm._v(_vm._s(_vm.i18n.lbl_delegate_btn()))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs" },
        [
          _c("SelectField", {
            attrs: {
              label: _vm.i18n.lbl_approvers(),
              values: _vm.formatApprovers
            },
            model: {
              value: _vm.user,
              callback: function($$v) {
                _vm.user = $$v
              },
              expression: "user"
            }
          }),
          _vm._v(" "),
          _c("DateFieldFlatpickr", {
            staticClass: "date-picker",
            attrs: {
              minDate: new Date(new Date().setHours(0, 0, 0, 0)),
              label: _vm.i18n.lbl_start_date(),
              title: "Choose before this date",
              clearable: ""
            },
            model: {
              value: _vm.from,
              callback: function($$v) {
                _vm.from = $$v
              },
              expression: "from"
            }
          }),
          _vm._v(" "),
          _c("DateFieldFlatpickr", {
            staticClass: "date-picker",
            attrs: {
              minDate: new Date(new Date().setHours(0, 0, 0, 0)),
              label: _vm.i18n.lbl_end_date(),
              title: "Choose before this date",
              clearable: ""
            },
            model: {
              value: _vm.to,
              callback: function($$v) {
                _vm.to = $$v
              },
              expression: "to"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "red" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.close }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.disabledDelegate },
              on: { click: _vm.delegateHandler }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_delegate_btn()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-132c4787", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132c4787","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/widrawalRequest/DelegateModal.vue
// module id = OyyU
// module chunks = 1